function Element(img, title, desc, link, isBlank) {
    return (
      <a className="element row" href={link} target={isBlank?"_blank":"_self"}>
        <div className="img col-md-4">
          <img src={img} />
        </div>
        <div className="text col-md-8">
          <h2>{title}</h2>
          <p>{desc}</p>
        </div>
      </a>
    );
}

export default Element;